module.exports = __webpack_public_path__ + "img/source0_2.dcc9173a.png";